module.exports = __webpack_public_path__ + "img/vanguards_1.0f9b75b.jpg";